import React from "react";
import { useI18n } from "@/contexts/I18nContext";
import { Globe } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

export default function LanguageSwitcher() {
  const { lang, setLang, locales, localeName } = useI18n();
  const flags = { ar: "🇸🇦", en: "🇺🇸", tr: "🇹🇷" };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="w-9 h-9 grid place-items-center rounded-md border border-border hover:bg-muted transition text-sm gap-1" data-testid="lang-switcher" title="Language / اللغة / Dil">
          <span className="text-base leading-none">{flags[lang] || "🌐"}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" data-testid="lang-menu">
        {locales.map(l => (
          <DropdownMenuItem key={l} onClick={()=>setLang(l)} className={l === lang ? "bg-primary/10 font-bold" : ""} data-testid={`lang-${l}`}>
            <span className="me-2">{flags[l] || "🌐"}</span> {localeName(l)}
            {l === lang && <span className="ms-auto text-primary">✓</span>}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
